/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 在庫数に受注済出荷予定を含める
 * @export
 * @interface CalcStockShippingorderFlg
 */
export interface CalcStockShippingorderFlg {
}

/**
 * Check if a given object implements the CalcStockShippingorderFlg interface.
 */
export function instanceOfCalcStockShippingorderFlg(value: object): value is CalcStockShippingorderFlg {
    return true;
}

export function CalcStockShippingorderFlgFromJSON(json: any): CalcStockShippingorderFlg {
    return CalcStockShippingorderFlgFromJSONTyped(json, false);
}

export function CalcStockShippingorderFlgFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalcStockShippingorderFlg {
    return json;
}

export function CalcStockShippingorderFlgToJSON(json: any): CalcStockShippingorderFlg {
    return CalcStockShippingorderFlgToJSONTyped(json, false);
}

export function CalcStockShippingorderFlgToJSONTyped(value?: CalcStockShippingorderFlg | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

